import * as angular from "angular";
import {Endpoints} from "../../shared/config/constant.module";
import {apsCommands} from "../../shared/dto/aps.commands";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import HttpServiceName, {HttpService} from "../http/http.service";
let requires = [HttpServiceName];

export interface PlantService {
  getPlants(): angular.IPromise<apsViewModels.PlantInfo[]>;
  updatePlant(plant: apsCommands.EditPlant): angular.IPromise<any>;
  getPlatFeatureSettings(plantId: string):angular.IPromise<apsViewModels.PlantFeatureSettings>;
}

class PlantSvc implements PlantService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  getPlants(): angular.IPromise<apsViewModels.PlantInfo[]> {
    return this.httpService.get<apsViewModels.PlantInfo[]>(Endpoints.PLANT_LIST);
  }

  updatePlant(plant: apsCommands.EditPlant): angular.IPromise<any> {
    let url = Endpoints.PLANT_LIST + '/' + plant.id;
    return this.httpService.put(url, plant);
  }

  getPlatFeatureSettings(plantId: string): angular.IPromise<apsViewModels.PlantFeatureSettings> {
    let url = Endpoints.PLANT_LIST + '/PlantFeatureSettings/' + plantId;
    return this.httpService.get(url);
  }

}

export default angular
  .module('aps.services.plant', requires)
  .service('plantService', PlantSvc)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/plant/plant.service.ts